import request from '@/services/api';

export const imgUrl = 'https://api.wetigu.com';
export function bannerList(query: Record<string, unknown>) {
  return request({
    url: '/homeBanner/list',
    method: 'post',
    data: query
  })
}

export function onedepartmentList(query: Record<string, unknown>) {
  return request({
    url: 'category/list',
    method: 'post',
    data: query
  })
}

export function categoryList(query: Record<string, unknown>) {
  return request({
    url: '/category/treeByType',
    method: 'post',
    data: query
  })
}
export function productList(query: Record<string, unknown>) {
  return request({
    url: '/product/listPage',
    method: 'post',
    data: query
  })
}
export function attributeList(query: Record<string, unknown>) {
  return request({
    url: '/attribute/list',
    method: 'post',
    data: query
  })
}
export function productDetail(id: number) {
  return request({
    url: '/product/getProductInfo/' + id,
    method: 'get',
  })
}
export function productParent(id: number) {
  return request({
    url: '/category/getCategoryParent/' + id,
    method: 'get',
  })
}
export function hotProductList(query: Record<string, unknown>) {
  return request({
    url: 'product/listPage',
    method: 'post',
    data: query
  })
}

// 商品评论
export function productReviewList(params: Record<string, unknown>) {
  return request({
    url: '/product/review/page',
    method: 'get',
    params: params
  })
}

//获取最新10条评论
export function productLatestReviews(data: Record<string, unknown>) {
  return request({
    url: 'product/review/latest' ,
    method: 'get',
    params: data
  })
}


